module.exports = __webpack_public_path__ + "static/media/D1.d0452ace.png";